'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _mobxReact = require('mobx-react');

var _utils = require('@dekk/utils');

var _deck = require('@dekk/deck');

var _deck2 = _interopRequireDefault(_deck);

var _speakerWrapper = require('./speaker-wrapper');

var _speakerWrapper2 = _interopRequireDefault(_speakerWrapper);

var _views = require('./views');

var _views2 = _interopRequireDefault(_views);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A wrapper around the slides.
 *
 * @class SpeakerDeck
 * @param {Object} props
 *   The properties
 * @param {(Slide|Slide[]|Elements|Elements[]|Plugins|Plugins[])} props.children
 * @param {?(String|Array)} props.mixin
 */
var SpeakerDeck = (0, _mobxReact.observer)(_class = function (_Deck) {
  _inherits(SpeakerDeck, _Deck);

  function SpeakerDeck() {
    _classCallCheck(this, SpeakerDeck);

    return _possibleConstructorReturn(this, (SpeakerDeck.__proto__ || Object.getPrototypeOf(SpeakerDeck)).apply(this, arguments));
  }

  _createClass(SpeakerDeck, [{
    key: 'render',


    /**
     * @private
     * @return {Wrapper}
     *   The entire Deck inside a Wrapper
     */
    value: function render() {
      var view = this.speakerSlides;
      var mixin = (0, _styledComponents.css)(['', ';'], this.props.mixin);
      return _react2.default.createElement(
        _deck.Wrapper,
        { mixin: mixin },
        this.plugins,
        this.elements,
        _react2.default.createElement(
          _speakerWrapper2.default,
          null,
          _react2.default.createElement(
            _views2.default,
            null,
            view
          )
        )
      );
    }
  }, {
    key: 'speakerSlides',


    /**
     * Setup slides fr the seaker.
     * Fills the slides with modified properties to show future states
     * @private
     */
    get: function get() {
      var _store = this.store,
          slideIndex = _store.slideIndex,
          fragmentOrder = _store.fragmentOrder;

      // We need a maximum of 2 slides `[current, next]`

      var filteredSlides = this.slides.filter(function (c, i) {
        return (0, _utils.range)(i, slideIndex + 2, slideIndex);
      });

      var _filteredSlides = _slicedToArray(filteredSlides, 1),
          currentSlide = _filteredSlides[0];

      var currentView = (0, _react.cloneElement)(currentSlide, {
        fragmentOrder: fragmentOrder,
        slideIndex: slideIndex,
        direction: 0,
        present: true,
        isCurrent: true,
        key: 'currentView'
      });

      return currentView;
    }
  }], [{
    key: 'propTypes',

    /**
     * @private
     */
    get: function get() {
      return {
        mixin: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string]),
        children: _propTypes2.default.node.isRequired
      };
    }

    /**
     * @private
     */

  }, {
    key: 'defaultProps',
    get: function get() {
      return {
        mixin: undefined
      };
    }
  }]);

  return SpeakerDeck;
}(_deck2.default)) || _class;

exports.default = SpeakerDeck;